export const USER_ACCOUNT_ROLE_KEYS = {
  GLOBALADMIN: "GLOBALADMIN",
  LOCATION_ADMIN: "LOCATIONADMIN",
  USER: "USER",
  USER_SMS: "USERSMS",
  GUEST: "GUEST",
  INACTIVE: "INACTIVE",
  GRASSHOPPER: "GRASSHOPPER",
  GRASSHOPPERSMS: "GRASSHOPPERSMS",
  GRASSHOPPERGLOBAL: "GRASSHOPPERGLOBAL",
  USER_OUT_CALL: "USEROUTCALL",
  PARTNERS: "PARTNERS",
  BILLING_ADMIN: "BILLING_ADMIN",
};

export const TextRestrictedRoles = [
  USER_ACCOUNT_ROLE_KEYS.USER,
  USER_ACCOUNT_ROLE_KEYS.GUEST,
  USER_ACCOUNT_ROLE_KEYS.GRASSHOPPERGLOBAL,
  USER_ACCOUNT_ROLE_KEYS.GRASSHOPPER,
  USER_ACCOUNT_ROLE_KEYS.INACTIVE,
  USER_ACCOUNT_ROLE_KEYS.USER_OUT_CALL,
];
export const BlockedContactsRestrictedRoles = [
  USER_ACCOUNT_ROLE_KEYS.GUEST,
  USER_ACCOUNT_ROLE_KEYS.INACTIVE,
];
